import React, { useEffect, useState } from 'react';
import { CalloutCard } from '@shopify/polaris';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const [counts, setCounts] = useState({
    submited: 0,
    draft: 0,
    production: 0,
    shipping: 0,
    delivered: 0
  });

  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    const decoded = jwtDecode(token);
    const checkRole = decoded.role;
    const checkIds = decoded.ids;
    const queryParam = checkRole === 'sales' ? `?repsid=${checkIds}` : '';
    const baseUrl = process.env.REACT_APP_API_URL;

    if (!token) return;

    fetch(`${baseUrl}/api/orders/status-counts${queryParam}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    })
      .then(async (response) => {
        const data = await response.json();
        if (!response.ok) {
          throw new Error("failed!");
        }
        setCounts(data.statusCounts);
        setLoading(false);
      })
      .catch(error => {
        console.error('Failed to fetch status counts:', error);
        setLoading(false);
      });
  }, []);

  return (
    <div className='dashboard-data-sales'>
      <div className='button_option'>
        <h2>Home</h2>
      </div>

      <div className='count-status'>
        <CalloutCard
          title="Submitted Orders"
          primaryAction={{
            content: 'View Submited Orders',
            onClick: () => navigate(`orders?status=submitted`)
          }}
        >
          <p>View all your orders that have been successfully Submitted.</p>
          <span className='ordercounts'>{loading ? 'Loading...' : counts.submited}</span>
        </CalloutCard>

        <CalloutCard
          title="In Production Orders"
          primaryAction={{
            content: 'View Production Orders',
            onClick: () => navigate(`orders?status=production`)
          }}
        >
          <p>These orders are currently being processed and will be delivered soon.</p>
          <span className='ordercounts'>{loading ? 'Loading...' : counts.production}</span>
        </CalloutCard>

        <CalloutCard
          title="Shipping Orders"
          primaryAction={{
            content: 'View Shipping Orders',
            onClick: () => navigate(`orders?status=shipping`)
          }}
        >
          <p>Your orders are currently in transit and will arrive soon.</p>
          <span className='ordercounts'>{loading ? 'Loading...' : counts.shipping}</span>
        </CalloutCard>

        <CalloutCard
          title="Delivered Orders"
          primaryAction={{
            content: 'View Delivered Orders',
            onClick: () => navigate(`orders?status=delivered`)
          }}
        >
          <p>Your orders have successfully reached you.</p>
          <span className='ordercounts'>{loading ? 'Loading...' : counts.delivered}</span>
        </CalloutCard>
      </div>
    </div>
  );
};

export default Home;
